import React from 'react'

import './LogoStyles.less'

export default () => (
  <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M198.332 165.178C201.043 165.767 203.626 163.519 204.102 160.151C204.607 161.046 205.113 161.943 205.619 162.841C205.144 166.208 202.559 168.457 199.851 167.868C199.346 166.971 198.839 166.074 198.332 165.178Z"
      fill="#FADB14"
    />
    <path
      d="M118.264 237.216C120.975 237.805 123.558 235.555 124.033 232.188C124.539 233.084 125.045 233.981 125.55 234.878C125.076 238.245 122.491 240.496 119.783 239.906C119.277 239.008 118.771 238.111 118.264 237.216Z"
      fill="#5EEB9D"
    />
    <path
      d="M204.387 108.807C205.524 111.919 208.475 113.302 210.983 111.889C210.673 112.915 210.362 113.94 210.05 114.965C207.542 116.375 204.591 114.994 203.455 111.88C203.767 110.857 204.078 109.832 204.387 108.807Z"
      fill="#8743AA"
    />
    <path
      d="M186.842 86.7004C187.3 83.3288 185.471 80.1365 182.757 79.5686C183.475 78.9332 184.193 78.2981 184.912 77.6631C187.625 78.231 189.454 81.4247 188.998 84.7949C188.28 85.4304 187.561 86.0655 186.842 86.7004Z"
      fill="#00678A"
    />
    <path
      d="M23.9193 73.0939C24.3769 69.7224 22.5485 66.5299 19.834 65.962C20.5518 65.3266 21.2703 64.6915 21.9895 64.0566C24.7019 64.6245 26.5314 67.8181 26.0748 71.1884C25.357 71.8238 24.6385 72.4589 23.9193 73.0939Z"
      fill="#8743AA"
    />
    <path
      d="M79.4368 192.558C79.8945 189.186 78.066 185.994 75.3516 185.426C76.0694 184.791 76.7878 184.155 77.507 183.521C80.2194 184.088 82.0488 187.282 81.5923 190.653C80.8745 191.288 80.156 191.923 79.4368 192.558Z"
      fill="#8743AA"
    />
    <path
      d="M221.838 66.215C224.531 66.9199 227.173 64.7795 227.74 61.4326C228.222 62.3496 228.703 63.2673 229.185 64.1857C228.619 67.5293 225.975 69.6709 223.284 68.9681C222.801 68.0511 222.319 67.1334 221.838 66.215Z"
      fill="#FADB14"
    />
    <path
      d="M6.41364 107.632C5.44827 104.43 2.57761 102.806 0 104.007C0.364622 103.011 0.729781 102.014 1.09548 101.016C3.67095 99.8169 6.54321 101.439 7.50912 104.64C7.14451 105.637 6.77935 106.634 6.41364 107.632Z"
      fill="#FADB14"
    />
    <path
      d="M73.3107 146.635C73.5009 150.045 75.881 152.618 78.6257 152.38C78.0469 153.208 77.467 154.032 76.8893 154.861C74.1435 155.096 71.7643 152.522 71.5742 149.112C72.1531 148.288 72.7319 147.462 73.3107 146.635Z"
      fill="#11D175"
    />
    <path
      d="M53.9121 84.6814C56.6381 84.2116 58.5407 81.0846 58.1614 77.6982C58.8657 78.3595 59.5688 79.0199 60.271 79.6796C60.6492 83.0673 58.7477 86.1923 56.0216 86.6641C55.3195 86.0027 54.6163 85.3419 53.9121 84.6814Z"
      fill="#00678A"
    />
    <path
      d="M165.071 43.1556C161.536 43.2769 164.077 49.7351 160.541 49.8591C159.867 49.1549 159.191 48.4507 158.516 47.7466C162.051 47.6245 159.51 41.1664 163.045 41.0425C163.721 41.7466 164.396 42.451 165.071 43.1556Z"
      fill="#8743AA"
    />
    <path
      d="M171.494 212.898C168.053 211.885 169.168 218.938 165.726 217.927C165.219 217.03 164.713 216.133 164.207 215.237C167.649 216.249 166.533 209.196 169.976 210.208C170.481 211.105 170.987 212.001 171.494 212.898Z"
      fill="#FADB14"
    />
    <path
      d="M69.1741 222.08C66.7439 225.273 72.2167 227.612 69.7864 230.803C68.9088 230.896 68.0301 230.993 67.1524 231.086C69.5827 227.895 64.1098 225.559 66.5401 222.366C67.4188 222.272 68.2968 222.177 69.1741 222.08Z"
      fill="#00678A"
    />
    <path
      d="M147.896 1.62443C144.436 2.53753 147.87 8.32411 144.412 9.23524C143.647 8.69268 142.878 8.15211 142.113 7.60823C145.573 6.69763 142.136 0.913143 145.597 0C146.364 0.543868 147.13 1.08535 147.896 1.62443Z"
      fill="#11D175"
    />
    <path
      d="M36.8505 20.6465C38.5525 24.4989 42.0217 18.7449 43.7212 22.5961C43.5238 23.6623 43.3288 24.7325 43.1304 25.7994C41.431 21.947 37.9637 27.7029 36.2617 23.8505C36.4597 22.781 36.6559 21.7129 36.8505 20.6465Z"
      fill="#5EEB9D"
    />
    <path
      d="M7.50977 172.117C7.96629 172.031 8.37932 171.781 8.67674 171.412C8.97416 171.042 9.13709 170.576 9.13709 170.095C9.13709 169.613 8.97416 169.147 8.67674 168.778C8.37932 168.408 7.96629 168.159 7.50977 168.073"
      fill="#12B1D6"
    />
    <path
      d="M192.217 15.9184C190.729 15.9184 189.52 14.4153 189.52 12.5675C189.52 10.7198 190.729 9.2168 192.217 9.2168C193.704 9.2168 194.914 10.7199 194.914 12.5676C194.914 14.4153 193.704 15.9184 192.217 15.9184ZM192.217 10.5459C191.744 10.5944 191.309 10.8334 191.005 11.2115C190.7 11.5896 190.551 12.0765 190.589 12.5676C190.546 12.8148 190.556 13.0688 190.618 13.3117C190.68 13.5546 190.792 13.7805 190.948 13.9733C191.103 14.1661 191.297 14.3212 191.516 14.4277C191.735 14.5341 191.975 14.5893 192.217 14.5893C192.459 14.5893 192.698 14.5341 192.917 14.4277C193.137 14.3212 193.331 14.1661 193.486 13.9733C193.641 13.7805 193.754 13.5546 193.816 13.3117C193.877 13.0688 193.887 12.8148 193.844 12.5676C193.882 12.0765 193.733 11.5896 193.429 11.2115C193.124 10.8334 192.689 10.5944 192.217 10.5459Z"
      fill="#12B1D6"
    />
    <path
      d="M35.2021 142.868C33.7148 142.868 32.5049 141.365 32.5049 139.518C32.5049 137.67 33.7148 136.167 35.2021 136.167C36.6893 136.167 37.8993 137.67 37.8993 139.518C37.8993 141.365 36.6894 142.868 35.2021 142.868ZM35.2021 137.496C34.7456 137.582 34.3325 137.831 34.0351 138.201C33.7377 138.57 33.5748 139.036 33.5748 139.518C33.5748 139.999 33.7377 140.465 34.0351 140.835C34.3325 141.204 34.7456 141.454 35.2021 141.539C35.6586 141.454 36.0716 141.204 36.3691 140.835C36.6665 140.465 36.8294 139.999 36.8294 139.518C36.8294 139.036 36.6665 138.57 36.3691 138.201C36.0716 137.831 35.6586 137.582 35.2021 137.496Z"
      fill="#12B1D6"
    />
    <path
      d="M238.904 176.177C237.939 172.974 235.068 171.351 232.49 172.551C232.855 171.556 233.22 170.559 233.586 169.561C236.161 168.361 239.033 169.984 239.999 173.185C239.635 174.182 239.27 175.179 238.904 176.177Z"
      fill="#12B1D6"
    />
    <path
      d="M146.766 102.555C147.234 103.023 147.5 103.656 147.5 104.32V152.5C147.5 153.883 146.383 155 145 155H95C93.6172 155 92.5 153.883 92.5 152.5V87.5C92.5 86.1172 93.6172 85 95 85H128.18C128.844 85 129.484 85.2656 129.953 85.7344L146.766 102.555ZM141.734 105.469L127.031 90.7656V105.469H141.734ZM105 117.656C104.834 117.656 104.675 117.722 104.558 117.839C104.441 117.957 104.375 118.115 104.375 118.281V122.031C104.375 122.197 104.441 122.356 104.558 122.473C104.675 122.59 104.834 122.656 105 122.656H135C135.166 122.656 135.325 122.59 135.442 122.473C135.559 122.356 135.625 122.197 135.625 122.031V118.281C135.625 118.115 135.559 117.957 135.442 117.839C135.325 117.722 135.166 117.656 135 117.656H105ZM105 128.281C104.834 128.281 104.675 128.347 104.558 128.464C104.441 128.582 104.375 128.74 104.375 128.906V132.656C104.375 132.822 104.441 132.981 104.558 133.098C104.675 133.215 104.834 133.281 105 133.281H119.375C119.541 133.281 119.7 133.215 119.817 133.098C119.934 132.981 120 132.822 120 132.656V128.906C120 128.74 119.934 128.582 119.817 128.464C119.7 128.347 119.541 128.281 119.375 128.281H105Z"
      fill="#11D175"
    />
  </svg>
)
